<div class="dialogHead">
    <div style="font-weight: bold;">
        <!-- You're performing quick entry for containers. These details won't be saved in the masters.  -->
        Please confirm container allocation before saving the DO, Containers having error(s) will not alloted.
    </div>
    <!-- <div style="color: red; font-weight: bold;">
        Click on save button to mark valid containers off-hired.
    </div> -->
</div>

<mat-dialog-content>
    <div class="setTable">
        <mat-table [dataSource]="dataSource" matSort>
            <ng-container [matColumnDef]="'container_number'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Container Number</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <span>
                        {{data?.container_number }}
                    </span>
                </mat-cell>

            </ng-container>
            <ng-container [matColumnDef]="'size'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Size-Type</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <div>
                        <div>
                            {{(data?.size ? data?.size.size : '-') + ' ' + (data?.type ? data?.type.code : '-')}}
                        </div>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'owner'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Ownership</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    {{data?.ownership ? data?.ownership.value : '-'}}
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'lifecycle'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    {{data?.lifecycle ? data?.lifecycle.name : '-'}}
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'mnr_status'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>MNR Status</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    <mat-chip [style.background-color]="data?.mnr_status ? data?.mnr_status?.color_code : '#ff000047'">
                        {{data?.mnr_status ? (data?.mnr_status?.value == 'Mark Available' ? 'Available' :
                        data?.mnr_status?.value) : '-'}}
                    </mat-chip>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'current_depot'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Current Depot</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    {{data?.current_depot ? data?.current_depot.display_name : '-'}}
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'errors'">
                <mat-header-cell *matHeaderCellDef>Error Messages</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    <div *ngIf="data.has_errors" class="depotCollection">
                        <!-- <li *ngFor="let error of data.errors">
                            <span>{{ error }}</span>
                        </li> -->
                        <span>
                            {{data?.errors[0]}}
                        </span>
                        <span class="additionalError" *ngIf="data?.errors.length > 1" [matTooltipShowDelay]="400"
                            [matTooltip]="data?.errors | errorsToolTip" matTooltipClass="tooltip-list">
                            {{data?.errors?.length>1 ? "+"+(data?.errors?.length-1)+" more errors" :
                            data?.errors?.length==1 ? "+"+(data?.errors?.length-1)+" more errors":''}}
                        </span>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'action'">
                <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12">
                    <div class="enableDelete">
                        <i class="flaticon-delete" matTooltip="Delete Container" (click)="removeContainer(data)"></i>
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns; let index"
                [style.background-color]="row.has_errors ? '#ff000047' : 'white'"
                [style.color]="row.has_errors ? 'white' : 'black'" [class.blur]="loading">
            </mat-row>
        </mat-table>
        <div class="loadingData" [class.d-none]="!loading">
            <logzy-gear-loader></logzy-gear-loader>
        </div>
        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button mat-dialog-close class="Cancel" [mat-dialog-close]="false">Cancel </button>
    <button mat-raised-button class="Save" [disabled]="disableSave" (click)="postReleaseOrder()">
        <span *ngIf="!disableSave">
            Save
        </span>
        <div *ngIf="disableSave" class="p03">
            <i class="flaticon-loading spin"></i>
            <span>Confirming...</span>
        </div>
    </button>
</mat-dialog-actions>